import {
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { NavigationEnd,Router } from '@angular/router';
import {
  AlertController,
  NavController,
  Platform,AnimationController
} from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { App } from '@capacitor/app';

// import { Storage } from '@ionic/storage';
import { DataService } from './services/data.service';
import { MenuService } from './services/menu.service';
import { StatusBar } from '@capacitor/status-bar';
import { Location } from '@angular/common';
import { SplashScreen } from '@capacitor/splash-screen';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  hover_menu = false;
  sub_category = false;
  
  myCustomPageTransition = ((baseEl: any, opts?: any) => { 
    var anim1 = this.animationCtrl.create()
      .addElement(opts.leavingEl)
      .duration(1000)
      .iterations(1)
      .easing('ease-out')
      .fromTo('opacity', '1', '0.0')
    var anim2 = this.animationCtrl.create()
      .addElement(opts.enteringEl)
      .duration(1000)
      .iterations(1)
      .easing('ease-out')
      .fromTo('opacity', '0.0', '1')
     var anim2 = this.animationCtrl.create()
      .duration(1000)
      .iterations(1)
      .addAnimation([anim1, anim2]);
    return anim2;
  });
  // db.tabs = false;
  
  constructor(private appVersion: AppVersion,
    private platform: Platform,private animationCtrl:AnimationController,
    // private splashScreen: SplashScreen,
    // private statusBar: StatusBar
    private router: Router, public alertCtrl: AlertController, private storage: Storage,
    public menu: MenuService, private navCtrl: NavController, public db:DataService,private location: Location
  ) {
    this.db.authendicate();
    this.initializeApp();
    this.get_wallet_settings();
    this.db.check_mobile();
  }
  @HostListener('window:resize', ['$event'])
  resize(event){
    let size = event.target.innerWidth;
      this.db.check_mobile();
  }

  added_animate = false;
  add_animatings:any = [];
  alert_animatings: any = [];
  alert_list: any = [];
  alert_animate = false;
  private database: any;
  
  ngOnInit() {

    //     onBackgroundMessage(messaging, (payload) => {
    //   console.log('[firebase-messaging-sw.js] Received background message ', payload);
    //   // Customize notification here
    //   const notificationTitle = 'Background Message Title';
    //   const notificationOptions = {
    //     body: 'Background Message body.',
    //     icon: '/firebase-logo.png'
    //   };

    //   this.registration.showNotification(notificationTitle,
    //     notificationOptions);
    // });
    //  this.db.watching().subscribe(res => {
    //   // console.log("id",res['last-updated-order'])
    //   var d = res['last-updated-order'];
    //   var d1 = d.split("(",2)
    //   // console.log(d1[0])
    //   // console.log(d1[1])
    //   // console.log(d1[1].indexOf('Order Placed') != -1)
    //   // d1[1].indexOf('Order Placed') != -1 ? alert('New Order Received'): '';
    //   // console.log(d1[1].indexOf('Order Placed') == -1)
    //   // this.page_no = 1
    //   // this.check_enter();
    // })
   
    this.storage_local_values();
    this.db.get_profiles();
    this.db.side_menu = true;
    this.sub = this.db.added_animate.subscribe((res:any) =>{
    this.added_animate = true;
      // console.log("animate ",res)
      this.add_animatings.push(res);
      setTimeout( () => {  this.add_animatings.shift();},2500);
    })

    this.sub1 = this.db.alert_animate.subscribe((res:any) =>{
      this.alert_animate = true;
      // console.log(res)
      if(res.alert){
        this.alert_list.push(res);
        setTimeout( () => {  this.alert_list.shift();}, this.db.ismobile? 2500: 2500 );
      }else{
        this.alert_animatings.push(res);
       setTimeout( () => {  this.alert_animatings.shift();}, this.db.ismobile? 2500: 2500 );
      }
    })

    var currentDate = new Date()
    var date = currentDate.getFullYear() + '-' + (this.menu.getPaddedComp(currentDate.getMonth() + 1)) + '-' + this.menu.getPaddedComp(currentDate.getDate());
    if(localStorage['__LastSyncedDate'] == date){
      this.storage.clear();
      this.menu.set_pos_menu();
      // this.menu.get_pos_all_products(); 
    }

    if(this.db.ismobile){
      if(this.platform.is('android')){
        this.get_app_version()
      }
      // console.log('url11111111');
      this.platform.ready().then(res =>{
        if((this.db.ismobile || res == 'ios' || res == 'ipad' || res == 'iphone' || res == 'mobile' || res == 'tablet') && res != 'dom'){
          this.get_oneSignal_id();
          StatusBar.setBackgroundColor({color:'#256b5a'});
          this.platform.backButton.subscribe(() => {
            const url = this.router.url;
            // console.log('url',url);
            this.location.back();
          //   else if (url == "/home" || url == "/p/homepage") {
          //     App.exitApp();
          //   // navigator['app'].exitApp();
          // }
         })
        } 
     })
    } 



    this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          var path = event.url;
          this.db.path = event.url;
          if (path == '/admin-dashboard' || path == '/categorylist' || path == '/customers'|| path == '/orders' || path == '/discount' || path =='/my-accounts' || path == '/report' || path == '/') {
            this.db.tabs = true;
            // this.db.tabs_val = true;     
          }else{
            this.db.tabs = false;
            // this.db.tabs_val = false;     
          } 

          if(this.db.path.includes('/manage-price?product=')){
            // this.router.navigateByUrl('/product-list');
          }

        }
      });

    this.database = this.storage.create();

  }



  sub:any;
  sub1:any;

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.sub1.unsubscribe();
  }

  get_oneSignal_id(){
      this.db.get_oneSignal_id().subscribe(res =>{
        res.is_key && res.is_key != '' ? this.db.OneSignalInit(res.key) : '';
      },error => { console.log(JSON.stringify(error.json()));})
    }

  storage_local_values(){
    if(localStorage['domain_api_secret']){
      this.db.login_info.restaurant_name = localStorage['restaurant_name'];
      this.db.login_info.business = localStorage['business']
      this.db.cust_name = localStorage['restaurant_name'];
    }
  }

  get_app_version(){
      this.db.get_app_version().subscribe(res =>{
        if(res && res.version){
          this.appVersion.getVersionNumber().then(value =>{
            this.db.app_version = value;
            let new_version  = value
            let force = res && res.force ? res.force : false
            new_version != res.version && res.show_popup ? this.update_notify(res.version,new_version,force) : null
          })
  
        }
      })
    }
  
     async update_notify(version:any,new_version:any,force:any){
        const alert = await this.alertCtrl.create({
          header : 'Update Available',
          message :'A new version(' + version  + ') of this app is available for download. Must update it from PlayStore !',
          subHeader: 'current version : ' + new_version,
          buttons : [
            {
              text : 'cancel',
              handler: () => {
                force ? App.exitApp() : null
              }
            },
            {
              text:'Update',
              handler : () =>{
                window.open("https://play.google.com/store/apps/details?id=com.farmlink.seller", '_system');
                App.exitApp()
              }
            }
          ]
        })  
  
        await alert.present();
      }


  get_path(){
  // console.log('url')
  this.router.events.subscribe((event: any) => {
    if (event instanceof NavigationEnd) {
      this.db.path = event.url;
      // console.log('url',this.db.path)
      if(this.db.path ){
        this.menu.active_sub = ''
        this.db.path == '/admin-dashboard' ? this.menu.active_menu = 'Dashboard' : null;
        // this.db.path == '/customers' ? this.menu.active_menu = 'Customers' : null;
        this.db.path == '/orders' ? this.menu.active_menu = 'Orders' : null;
        this.db.path == '/pos' ? this.menu.active_menu = 'POS' : null;
        this.db.path == '/report' ? this.menu.active_menu = 'Report' : null;
     
        this.menu.active_menu = ''
        // this.db.path == '/categorylist' ? this.menu.active_sub = 'Category' : null;
        this.db.path == '/productlist' ? this.menu.active_sub = 'Product' : null;
        this.db.path == '/inventory' ? this.menu.active_sub = 'Inventory' : null;
      }
    }
  })
      // if(this.path == '/'){
 }

  initializeApp() {
    this.platform.ready().then(() => {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
    });
    this.router.events.subscribe((val: any) => {
      if(val && val.navigationTrigger == 'imperative') {
        this.menu.toggle_side_bar(val.url);
      }
    })
  }

  get_wallet_settings() {
    let d = {doctype: 'Wallet Settings'};
    this.db.get_shipping_settings(d)
    .subscribe((r:any) => {
      if(r.message) {
        this.db.wallet_settings = r.message;
        // if(this.wallet_settings.enable_customer_wallet) {
        //   this.get_customer_wallet();
        // }
      }
    }, error => {
      console.log(JSON.stringify(error.json()));
    })
  }

  route_to(route:any) {
    this.router.navigate([route]);
  }

  async logout() {
   // console.log('logout')

    let alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Do you really want to logout?',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            // this.router.navigateByUrl('/login');
            // this.router.navigate(["/"]);
            localStorage.clear();
            this.storage.remove('category_list');
            this.storage.remove('customer_list');
            this.storage.remove('inventroy_items');
            this.storage.remove('selectmenu');
            this.storage.clear();
             this.router.navigateByUrl('/')
            // location.href = '/';
          }
        }
      ]
    })
    await alert.present();
  }

  openPage(page:any) {
      // console.log("Page",page);
      this.sub_category = false;
      this.menu.active_sub = '';
    if(page.label == 'Inventory'){
      this.db.stack_tranfer = false;
      this.db.search_txt ='';
      this.db.get_values(); 
      this.navCtrl.navigateRoot([page.url], {});
    }else if(page.label == 'Products'){
      this.menu.active_menu = page.label;
      this.navCtrl.navigateRoot([page.url], {});
      // this.menu.enable_pos_menu = false;
    }else if(this.db.ismobile && page.label == 'My Profile'){
      this.navCtrl.navigateRoot('my-accounts', {});
    }
    else
      this.navCtrl.navigateRoot([page.url], {});
  }
  open_subpage(page:any){
    this.sub_category = true;
    this.menu.active_sub = page.label;
    this.menu.active_menu = '';
    this.navCtrl.navigateRoot([page.url], {});
  }

  Sub_category(){
    if(this.sub_category){
      this.sub_category = false;
    }else{
      this.sub_category = true;
    }
  }

}
